import { useEffect, useState } from 'react';
import { useSiteStore } from '@core/site/useSiteStore';
import type { Site } from '@core/generated/gql-types';
import type { SitesListView } from '@/modules/sites/views/sitesList.view';

type UseSitesListData = {
  sites: Site[];
  isLoading: boolean;
};

export const useSitesListData = (
  view: SitesListView,
  clientId: string | undefined,
): UseSitesListData => {
  const { fetchSitesForClient, getSitesForClient, isLoading } = useSiteStore();
  const [hasFetched, setHasFetched] = useState(false);

  useEffect(() => {
    if (view.query.sites.strategy !== 'clientSites') return;
    if (!clientId || hasFetched) return;
    fetchSitesForClient(clientId).finally(() => setHasFetched(true));
  }, [view.query.sites.strategy, clientId, hasFetched, fetchSitesForClient]);

  const sites = clientId ? getSitesForClient(clientId) : [];

  return { sites, isLoading };
};
